import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-contact-info',
  templateUrl: './contact-info.component.html',
  styleUrls: ['./contact-info.component.scss'],
})
export class ContactInfoComponent implements OnInit {
  constructor() {}

  ngOnInit() {}

  openLocation(){
    const url = `https://www.google.com/maps?q=${28.58656},${77.24038}`;
    window.open(url, '_blank');
  }
}
